import { Component, ReactNode } from 'react';
import { Maybe } from '../../types';

interface RefHolderState {
  ref: Maybe<HTMLElement>;
  setRef: (ref: Maybe<HTMLElement>) => void;
}

interface RefHolderProps {
  render: (state: RefHolderState) => ReactNode;
}

class RefHolder extends Component<RefHolderProps, RefHolderState> {
  public state: RefHolderState = {
    ref: null,
    setRef: (ref: Maybe<HTMLElement>) => {
      this.setState({ ref });
    }
  };

  public render() {
    const { render } = this.props;
    return render(this.state);
  }
}

export default RefHolder;
